import createStyleSheet from 'src/utilities/createStyleSheet'

export const imageDrawStyles = createStyleSheet({
  stage: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
})
